import { AdvancedSearchConfig, attachmentPhotoAdvancedSearchGroup } from "../forms/advanced-search/advanced-search-fields-def";
import { ColumnFormatted } from "./general";

export const audiovisualColumns: ColumnFormatted[] = [
  {
    type: "string",
    key: "audiovisuelDescriptionNumeroEnregistrement",
    visible: true,
  },
  {
    type: "image",
    key: "vignette",
    visible: true,
  },
  {
    type: "string",
    key: "audiovisuelDescriptionAuteur",
    visible: true,
  },
  {
    type: "boolean",
    key: "audiovisuelDescriptionAuteurAnonyme",
  },
  {
    type: "string",
    key: "audiovisuelDescriptionTitre",
    visible: true,
  },
  {
    type: "boolean",
    key: "audiovisuelDescriptionTitreSansTitre",
  },
  {
    type: "boolean",
    key: "audiovisuelDescriptionTitreInconnu",
  },
  {
    type: "string",
    key: "audiovisuelDescriptionEmission",
    visible: true,
  },
  {
    type: "string",
    key: "audiovisuelDescriptionSousTitre",
  },
  {
    type: "string",
    key: "audiovisuelDescriptionDateDeCreation",
    visible: true,
  },
  {
    type: "boolean",
    key: "audiovisuelDescriptionDateDeCreationInconnue",
  },
  {
    type: "string",
    key: "audiovisuelDescriptionDateDe1EreDiffusion",
  },
  {
    type: "boolean",
    key: "audiovisuelDescriptionDateDe1EreDiffusionInconnue",
  },
  {
    type: "string",
    key: "audiovisuelDescriptionType",
  },
  {
    type: "string",
    key: "audiovisuelDescriptionRealisation",
  },
  {
    type: "string",
    key: "audiovisuelDescriptionProduction",
  },
  {
    type: "string",
    key: "audiovisuelDescriptionDiffusion",
    visible: true,
  },
  {
    type: "string",
    key: "audiovisuelDescriptionDistribution",
  },
  {
    type: "string",
    key: "audiovisuelDescriptionPays",
  },
  {
    type: "richtext",
    key: "audiovisuelDescriptionResume",
  },
  {
    type: "string",
    key: "audiovisuelDescriptionTechniqueDuree",
  },
  {
    type: "string",
    key: "audiovisuelDescriptionTechniqueFormatCineVideo",
  },
  {
    type: "boolean",
    key: "audiovisuelDescriptionTechniqueCouleur",
  },
  {
    type: "string",
    key: "audiovisuelDescriptionTechniqueFormatSon",
  },
  {
    type: "string",
    key: "audiovisuelDescriptionTechniqueVersionLangue",
  },
  {
    type: "string",
    key: "audiovisuelDescriptionTechniqueSousTitre",
  },
  {
    type: "string",
    key: "audiovisuelDescriptionTechniqueAssistantRalisation",
  },
  {
    type: "string",
    key: "audiovisuelDescriptionTechniqueImage",
  },
  {
    type: "string",
    key: "audiovisuelDescriptionTechniqueMontage",
  },
  {
    type: "string",
    key: "audiovisuelDescriptionTechniqueMusique",
  },
  {
    type: "string",
    key: "audiovisuelDescriptionTechniqueSon",
  },
  {
    type: "string",
    key: "audiovisuelDescriptionTechniqueAutresPostesTechniques",
  },
  {
    type: "richtext",
    key: "audiovisuelDescriptionNotesDescriptionFilm",
  },
  {
    type: "richtext",
    key: "audiovisuelDescriptionNotesDeTravail",
  },
  {
    type: "string",
    key: "audiovisuelDescriptionTechniqueRole",
  },
  {
    type: "string",
    key: "audiovisuelDescriptionTechniqueActeur",
  },
  {
    type: "status",
    key: "audiovisuelPublicationStatus",
    visible: true,
  },
  {
    type: "richtext",
    key: "sources",
  },
];

export const audiovisualColumnsVisibility = audiovisualColumns.reduce(
  (acc, column) => ({
    ...acc,
    [column.key]: column.visible ?? true,
  }),
  {} as Record<string, boolean>,
);

export const audiovisualAdvancedSearchConfig: AdvancedSearchConfig = [
  {
    type: "group",
    label: "audiovisualDescription",
    fields: [
      { type: "string", key: "audiovisuelDescriptionNumeroEnregistrement" },
      { type: "string", key: "audiovisuelDescriptionAuteur" },
      { type: "boolean", key: "audiovisuelDescriptionAuteurAnonyme" },
      { type: "string", key: "audiovisuelDescriptionTitre" },
      { type: "boolean", key: "audiovisuelDescriptionTitreSansTitre" },
      { type: "boolean", key: "audiovisuelDescriptionTitreInconnu" },
      { type: "string", key: "audiovisuelDescriptionEmission" },
      { type: "string", key: "audiovisuelDescriptionSousTitre" },
      { type: "string", key: "audiovisuelDescriptionDateDeCreation" },
      { type: "boolean", key: "audiovisuelDescriptionDateDeCreationInconnue" },
      { type: "string", key: "audiovisuelDescriptionDateDe1EreDiffusion" },
      {
        type: "boolean",
        key: "audiovisuelDescriptionDateDe1EreDiffusionInconnue",
      },
      { type: "string", key: "audiovisuelDescriptionType" },
      { type: "string", key: "audiovisuelDescriptionRealisation" },
      { type: "string", key: "audiovisuelDescriptionProduction" },
      { type: "string", key: "audiovisuelDescriptionDiffusion" },
      { type: "string", key: "audiovisuelDescriptionDistribution" },
      { type: "string", key: "audiovisuelDescriptionPays" },
      { type: "string", key: "audiovisuelDescriptionResume" },
      { type: "string", key: "audiovisuelDescriptionTechniqueDuree" },
      { type: "string", key: "audiovisuelDescriptionTechniqueFormatCineVideo" },
      { type: "boolean", key: "audiovisuelDescriptionTechniqueCouleur" },
      { type: "string", key: "audiovisuelDescriptionTechniqueFormatSon" },
      { type: "string", key: "audiovisuelDescriptionTechniqueVersionLangue" },
      { type: "string", key: "audiovisuelDescriptionTechniqueSousTitre" },
      {
        type: "string",
        key: "audiovisuelDescriptionTechniqueAssistantRalisation",
      },
      { type: "string", key: "audiovisuelDescriptionTechniqueImage" },
      { type: "string", key: "audiovisuelDescriptionTechniqueMontage" },
      { type: "string", key: "audiovisuelDescriptionTechniqueMusique" },
      { type: "string", key: "audiovisuelDescriptionTechniqueSon" },
      {
        type: "string",
        key: "audiovisuelDescriptionTechniqueAutresPostesTechniques",
      },
      { type: "string", key: "audiovisuelDescriptionNotesDescriptionFilm" },
      { type: "string", key: "audiovisuelDescriptionNotesDeTravail" },
    ],
  },
  {
    type: "group",
    label: "audiovisualSources",
    fields: [{ type: "string", key: "sources" }],
  },
  attachmentPhotoAdvancedSearchGroup,
];
